import { isNaN } from 'lodash';

const noop = () => {};
class WaitScreen {
  constructor({ countdownSeconds, onComplete = noop }) {
    if (Pollfish.helper.isCypressEnv()) {
      let urlCountdownSeconds = Pollfish.helper.getURLParameter(
        'countdownSeconds',
      );
      urlCountdownSeconds = parseInt(urlCountdownSeconds, 10);
      urlCountdownSeconds = isNaN(urlCountdownSeconds)
        ? 0
        : urlCountdownSeconds;
      this.countdownSeconds = urlCountdownSeconds;
    } else {
      this.countdownSeconds = countdownSeconds;
    }
    // this.countdownSeconds = 1;
    this.onComplete = onComplete;
  }

  renderCountdown = () => {
    const digits = this.countdownSeconds.toString().length;
    // for some reason the line-height of the span generates a + 8px difference than expected
    const randomFix = 8;
    let size = 150;
    if (digits > 2) {
      size += 30 * (digits - 2);
    }
    return `
      <div class="countdown">
        <p class="countdown__title">${Pollfish.ui.getText(
          'thank_you.incentive.new_email.title',
        )}</p>
        <span id="js-countdown" style="width: ${size +
          randomFix}px; line-height: ${size}px">${this.countdownSeconds}</span>
      </div>
    `;
  };

  renderHeader = () => {
    const title = Pollfish.ui.getText('sanity.screen_out.title');
    const subtitle = Pollfish.ui.getText('read_questions_carefully');
    const header = `
        <h1>${title}</h1>
        <p>${subtitle}</p>
      `;

    return `<div class="loading__header">${header}</div>`;
  };

  startCountdown = () => {
    // first render already contains the countdownSeconds
    let timeLeft = this.countdownSeconds - 1;
    this.timer = setInterval(() => {
      $('#js-countdown').text(timeLeft);
      timeLeft -= 1;
      if (timeLeft < 0) {
        this.onTimerFinish();
      }
    }, 1000);
  };

  onTimerFinish = () => {
    this.clearTimer();
    this.onComplete();
  };

  clearTimer = () => {
    clearInterval(this.timer);
  };

  render() {
    const htmlTemplate = `
      <div class="main-content__home loading">
        ${this.renderHeader()}
        <div class="loading__image-container">
          ${this.renderCountdown()}
        </div>
      </div>
      `;

    return htmlTemplate;
  }
}

export default WaitScreen;
